import { handleActions } from 'redux-actions';
import { stateUpdate, State, stateClear } from './action';

const initialState: State = {
};

const reducer = handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [String(stateClear)]: () => {
      return initialState;
    },
  },

  initialState,
);

export default reducer;
